import React from 'react';
import { InputContainer } from '../../../../../common/components/form/form.module';
import { AccordionContainer } from '../../../../../common/components/accordion/accordion.module';
import _ from 'lodash';
export const AnnouncementBasicInfoComponent = ({ handleFormAnnouncementItemChange, selectedAnnouncement ,announcementType}: any) => (
    <>
   {_.map(
                  selectedAnnouncement,
                  (selectedAnnouncements: any, index: any) => (

        <AccordionContainer
            child={
                <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>

                    <InputContainer
                        label="Announcment Type"
                        labelField="Text"
                        list={announcementType}
                        onValueChange={(event: any) => {
                            handleFormAnnouncementItemChange({
                                value: event.target.value,
                                field: 'AnnouncmentTypeId',
                                idx: index
                              });
                            } }
                        optionName='Choose announcement Type'
                        type="select"
                        value={selectedAnnouncements?.AnnouncmentTypeId}
                        valueField="Value"
                    />

                    <InputContainer
                        label="Title"
                        name="Title"
                        onValueChange={(event: any) => {
                            handleFormAnnouncementItemChange({
                                value: event.target.value,
                                field: 'Title',
                                idx: index
                              });
                            } }
                        type="text"
                        value={selectedAnnouncements?.Title}
                    />

                    <InputContainer
                        label="Description"
                        name="Description"
                        onValueChange={(event: any) => {
                            handleFormAnnouncementItemChange({
                                value: event.target.value,
                                field: 'Description',
                                idx: index
                              });
                            } }

                        type="text"
                        value={selectedAnnouncements?.Description}
                    />

                    <InputContainer
                        label="Published"
                        name="IsPublished"
                        onValueChange={(event: any) => {
                            handleFormAnnouncementItemChange({
                                value: event,
                                field: 'IsPublished',
                                idx: index
                              });
                            } }
                        type="checkbox"
                        value={selectedAnnouncements?.IsPublished}
                    />
                    <InputContainer
                        label="Limited To Route"
                        name="IsLimitedToRoute"
                        onValueChange={(event: any) => {
                            handleFormAnnouncementItemChange({
                                value: event,
                                field: 'IsLimitedToRoute',
                                idx: index
                              });
                            } }
                        type="checkbox"
                        value={selectedAnnouncements?.IsLimitedToRoute}
                    />
                    {selectedAnnouncements?.IsLimitedToRoute &&
                     <InputContainer
                        label="RoutePath"
                        name="RoutePath"
                        onValueChange={(event: any) => {
                            handleFormAnnouncementItemChange({
                                value:event.target.value,
                                field: 'RoutePath',
                                idx: index
                              });
                            } }
                        type="text"
                        value={selectedAnnouncements?.RoutePath}
                    />}
   <InputContainer
                        label="Display StartDate"
                        name="IsDisplayStartDateUtc"
                        onValueChange={(event: any) => {
                            handleFormAnnouncementItemChange({
                                value:event,
                                field: 'IsDisplayStartDateUtc',
                                idx: index
                              });
                            } }
                        type="checkbox"
                        value={selectedAnnouncements?.IsDisplayStartDateUtc}
                    />
                    {selectedAnnouncements?.IsDisplayStartDateUtc &&
                     <InputContainer
                        label="Start Date"
                        name="StartDateUtc"
                        onValueChange={(event: any) => {
                            handleFormAnnouncementItemChange({
                                value:event.target.value,
                                field: 'StartDateUtc',
                                idx: index
                              });
                            } }
                        type="date"
                        value={selectedAnnouncements?.StartDateUtc}
                    />}

<InputContainer
                        label="Display EndDateUtc"
                        name="IsDisplayEndDateUtc"
                        onValueChange={(event: any) => {
                            handleFormAnnouncementItemChange({
                                value:event,
                                field: 'IsDisplayEndDateUtc',
                                idx: index
                              });
                            } }
                        type="checkbox"
                        value={selectedAnnouncements?.IsDisplayEndDateUtc}
                    />
                    {selectedAnnouncement?.IsDisplayEndDateUtc &&
                     <InputContainer
                        label="End Date"
                        name="EndDateUtc"
                        onValueChange={(event: any) => {
                            handleFormAnnouncementItemChange({
                                value:event.target.value,
                                field: 'EndDateUtc',
                                idx: index
                              });
                            } }
                        type="date"
                        value={selectedAnnouncements?.EndDateUtc}
                    />}

<InputContainer
                        label="EnableLocation"
                        name="IsEnableLocation"
                        onValueChange={(event: any) => {
                            handleFormAnnouncementItemChange({
                                value:event,
                                field: 'IsEnableLocation',
                                idx: index
                              });
                            } }
                        type="checkbox"
                        value={selectedAnnouncements?.IsEnableLocation}
                    />
                    {selectedAnnouncements?.IsEnableLocation &&
                     <InputContainer
                        label="Location"
                        name="Location"
                        onValueChange={(event: any) => {
                            handleFormAnnouncementItemChange({
                                value:event.target.value,
                                field: 'Location',
                                idx: index
                              });
                            } }
                        type="text"
                        value={selectedAnnouncements?.Location}
                    />}
                    <InputContainer
                        label="RedirectionEnabled"
                        name="IsRedirectionEnabled"
                        onValueChange={(event: any) => {
                            handleFormAnnouncementItemChange({
                                value:event,
                                field: 'IsRedirectionEnabled',
                                idx: index
                              });
                            } }
                        type="checkbox"
                        value={selectedAnnouncements?.IsRedirectionEnabled}
                    />
                    {selectedAnnouncements?.IsRedirectionEnabled &&
                     <InputContainer
                        label="RedirectionURL"
                        name="RedirectionURL"
                        onValueChange={(event: any) => {
                            handleFormAnnouncementItemChange({
                                value:event.target.value,
                                field: 'RedirectionURL',
                                idx: index
                              });
                            } }
                        type="text"
                        value={selectedAnnouncements?.RedirectionURL}
                    />}
 <InputContainer
                        label="Contact Person Enabled"
                        name="IsContactPersonEnabled"
                        onValueChange={(event: any) => {
                            handleFormAnnouncementItemChange({
                                value:event,
                                field: 'IsContactPersonEnabled',
                                idx: index
                              });
                            } }
                        type="checkbox"
                        value={selectedAnnouncements?.IsContactPersonEnabled}
                    />
                    {selectedAnnouncements?.IsContactPersonEnabled &&
                     <><InputContainer
                            label="ContactPersonName"
                            name="ContactPersonName"
                            onValueChange={(event: any) => {
                                handleFormAnnouncementItemChange({
                                    value:event.target.value,
                                    field: 'ContactPersonName',
                                    idx: index
                                  });
                                } }
                            type="text"
                            value={selectedAnnouncements?.ContactPersonName} />
                            <InputContainer
                                label="ContactPersonTitle"
                                name="ContactPersonTitle"
                                onValueChange={(event: any) => {
                                    handleFormAnnouncementItemChange({
                                        value:event.target.value,
                                        field: 'ContactPersonTitle',
                                        idx: index
                                      });
                                    } }
                                type="text"
                                value={selectedAnnouncements?.ContactPersonTitle} /></>
                    }

<InputContainer
                        label="Contact PhoneNumber Enabled"
                        name="IsContactPhoneNumberEnabled"
                        onValueChange={(event: any) => {
                            handleFormAnnouncementItemChange({
                                value:event,
                                field: 'IsContactPhoneNumberEnabled',
                                idx: index
                              });
                            } }
                        type="checkbox"
                        value={selectedAnnouncements?.IsContactPhoneNumberEnabled}
                    />
                    {selectedAnnouncements?.IsContactPhoneNumberEnabled &&
                     <InputContainer
                        label="ContactPhoneNumber"
                        name="ContactPhoneNumber"
                        onValueChange={(event: any) => {
                            handleFormAnnouncementItemChange({
                                value:event.target.value,
                                field: 'ContactPhoneNumber',
                                idx: index
                              });
                            } }
                        type="text"
                        value={selectedAnnouncements?.ContactPhoneNumber}
                    />}

<InputContainer
                        label="Contact Email Enabled"
                        name="IsContactEmailEnabled"
                        onValueChange={(event: any) => {
                            handleFormAnnouncementItemChange({
                                value:event,
                                field: 'IsContactEmailEnabled',
                                idx: index
                              });
                            } }
                        type="checkbox"
                        value={selectedAnnouncements?.IsContactEmailEnabled}
                    />
                    {selectedAnnouncements?.IsContactEmailEnabled &&
                     <InputContainer
                        label="Contact Email"
                        name="Contact Email"
                        onValueChange={(event: any) => {
                            handleFormAnnouncementItemChange({
                                value:event.target.value,
                                field: 'ContactEmail',
                                idx: index
                              });
                            } }
                        type="text"
                        value={selectedAnnouncements?.ContactEmail}
                    />}

<InputContainer
                        label="Contact Address Enabled"
                        name="IsContactAddressEnabled"
                        onValueChange={(event: any) => {
                            handleFormAnnouncementItemChange({
                                value:event,
                                field: 'IsContactAddressEnabled',
                                idx: index
                              });
                            } }
                        type="checkbox"
                        value={selectedAnnouncements?.IsContactAddressEnabled}
                    />
                    {selectedAnnouncements?.IsContactAddressEnabled &&
                     <><InputContainer
                            label="Address1"
                            name="Address1"
                            onValueChange={(event: any) => {
                                handleFormAnnouncementItemChange({
                                    value:event.target.value,
                                    field: 'Address1',
                                    idx: index
                                  });
                                } }
                            type="text"
                            value={selectedAnnouncements?.Address1} /><InputContainer
                                label="Address2"
                                name="Address2"
                                onValueChange={(event: any) => {
                                    handleFormAnnouncementItemChange({
                                        value:event.target.value,
                                        field: 'Address2',
                                        idx: index
                                      });
                                    } }
                                type="text"
                                value={selectedAnnouncements?.Address2} />
                                <InputContainer
                                label="City"
                                name="City"
                                onValueChange={(event: any) => {
                                    handleFormAnnouncementItemChange({
                                        value:event.target.value,
                                        field: 'City',
                                        idx: index
                                      });
                                    } }
                                type="text"
                                value={selectedAnnouncements?.City} />
                                 <InputContainer
                                label="ZipPostalCode"
                                name="ZipPostalCode"
                                onValueChange={(event: any) => {
                                    handleFormAnnouncementItemChange({
                                        value:event.target.value,
                                        field: 'ZipPostalCode',
                                        idx: index
                                      });
                                    } }
                                type="text"
                                value={selectedAnnouncements?.ZipPostalCode} /></>
                    }

                </div>
            }
            expandedPanel="basicInfo"
            headerTitle="Basic Info"
        />
    )
)}
    </>
)
export default AnnouncementBasicInfoComponent;
